import { render, staticRenderFns } from "./order_history_bak.vue?vue&type=template&id=2d24e87c&scoped=true&"
import script from "./order_history_bak.vue?vue&type=script&lang=js&"
export * from "./order_history_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24e87c",
  null
  
)

export default component.exports